import * as Cookies from '../modules/helpers/cookies.js';

let getPosition = () => new Promise((resolve, reject) => {
    function success( position ){
        resolve( position );
    }

    function error( error ){
        reject( error );
    }

    navigator.geolocation.getCurrentPosition(success, error);
});

function formatGeoLocation( val ){
    val = ''+val;

    val = val.split('.').join('[dot]');
    val = val.split('-').join('[dash]');

    return val;
}

function fetchStoreLocation(){
    // console.log('fetchStoreLocation: Store ID: '+ Cookies.getCookie("RNRMyStore"));

    if(Cookies.getCookie("RNRMyStoreToken")){
        const fetchUrl = atob(Cookies.getCookie("RNRMyStoreToken"));

        if(fetchUrl){
            fetch(fetchUrl)
                .then(function(response, data){
                    if(response.ok){
                        let json = response.json().then(
                            data => {
                                if(data.locations[0]){
                                    const nearestLocationWidget = document.getElementsByClassName('nearest-location-widget');
                                    const nearestLocationName = document.getElementsByClassName('your-location');
                                    const nearestLocationUrl = document.getElementsByClassName('your-location-url');

                                    nearestLocationWidget[0].classList.add('resolved');


                                    nearestLocationName[0].innerHTML = data.locations[0].title;
                                    nearestLocationUrl[0].href = data.locations[0].link;

                                    if(window.innerWidth > 899){
                                        nearestLocationWidget[0].classList.add('revealed');

                                        nearestLocationWidget[0].querySelector('.modal-close').onclick = function(){
                                            nearestLocationWidget[0].classList.remove('revealed');
                                        };

                                        nearestLocationWidget[0].querySelector('.your-location-url').onclick = function(event){

                                            console.log('onclick', event);

                                            if(!nearestLocationWidget[0].classList.contains('revealed')){
                                                console.log('1');
                                                event.preventDefault();
                                                nearestLocationWidget[0].classList.add('revealed');
                                            }
                                        };
                                    }
                                }
                            }
                        ).catch(function (err) {
                            console.warn('An issue occured handling the JSON data response:', err);
                        });
                     }
                     else{
                        // console.log(response);
                    }

                })
                .catch(function (err) {
                    console.warn('An issue occured fetching a response from the API.', err);
                });
        }
    }

}

async function fetchUsersLocation(){
    let fetchLocations = await getPosition().then((position) => {

        var coords = position.coords;
        setNearestLocation(coords.latitude, coords.longitude);

    }).catch((error) => {
        // Test Only - must remove
        // setNearestLocation(39.956717, -74.8810715);

        console.warn(
            'Error getting users geo location: \n',
            error.message
        );
    });
}

function setNearestLocation(lat, lng){
    lat = formatGeoLocation(lat);
    lng = formatGeoLocation(lng);

    const fetchURL = '/locations_api/300/'+lat+'/'+lng+'/';
    const allStoresURL = '/distance_api/'+lat+'/'+lng+'/';

    fetch( fetchURL )
        .then(function(response, data){
            if(response.ok){
                let json = response.json().then(
                    data => {
                        Promise.resolve('Success').then(function() {
                            let expiration = Cookies.getExpirationDate( new Date().getTime() + ((36000 * 1000) * 12));

                            Cookies.setCookie("RNRMyStore", data.locations[0].id, expiration);
                            Cookies.setCookie("RNRMyStoreToken", btoa( fetchURL ), expiration);
                            Cookies.setCookie("RNRMyStoreDistanceToken", btoa( allStoresURL ), expiration);

                            fetchStoreLocation();
                        });
                    }
                ).catch(function (err) {
                    console.warn('An issue occured handling the JSON data response:', err);
                });
             }
             else{
                return Promise.reject(response);
            }

        })
        .catch(function (err) {
            console.warn('An issue occured fetching a response from the API.', err);
        });
}

if(!Cookies.getCookie("RNRMyStore")){
    fetchUsersLocation();
}
else{
    fetchStoreLocation();
}